import type { IAssetPosition, IAssetPositionResponse } from '@/service/vpc/types/IAssetPositionResponse';

/**
 * Filters asset positions to only return the latest position for each unit based on createdDateTime
 * @param response - Axios response containing asset position data
 * @returns Array of asset positions with only the latest position per chassisId
 */
export const getLatestPositions = (response: IAssetPositionResponse): IAssetPosition[] => {
  return response.assetPositions.reduce((acc, position) => {
    const existing = acc.find((p) => p.chassisId === position.chassisId);
    if (!existing || new Date(position.createdDateTime) > new Date(existing.createdDateTime)) {
      acc = acc.filter((p) => p.chassisId !== position.chassisId);
      acc.push(position);
    }
    return acc;
  }, [] as IAssetPosition[]);
};
